import type { AgentToolDef, AgentWorkflowDef, AgentWorkflowStep } from "@/types/agentWorkflow";

export const DEFAULT_ENABLED_TOOL_IDS = [
  "web_search",
  "file_search",
  "code_interpreter",
  "image_generation",
];

export const AGENT_TOOL_DEFS: AgentToolDef[] = [
  {
    id: "web_search",
    name: "web_search",
    description: "Search the web for up-to-date information.",
    inputSchema: { type: "object", properties: { query: { type: "string", description: "Search query" } }, required: ["query"] },
  },
  {
    id: "file_search",
    name: "file_search",
    description: "Search the user's connected files and knowledge base.",
    inputSchema: { type: "object", properties: { query: { type: "string", description: "Search query" } }, required: ["query"] },
  },
  {
    id: "code_interpreter",
    name: "code_interpreter",
    description: "Run Python code to compute, analyze data, or generate outputs.",
    inputSchema: { type: "object", properties: { code: { type: "string", description: "Python code to run" } }, required: ["code"] },
  },
  {
    id: "image_generation",
    name: "image_generation",
    description: "Generate an image from a natural language description.",
    inputSchema: { type: "object", properties: { prompt: { type: "string", description: "Image description" } }, required: ["prompt"] },
  },
];

export function getAgentToolDef(id: string): AgentToolDef | undefined {
  return AGENT_TOOL_DEFS.find((t) => t.id === id);
}

export function getAgentToolsByIds(ids: string[]): AgentToolDef[] {
  return ids.map((id) => getAgentToolDef(id)).filter((t): t is AgentToolDef => !!t);
}

export function createBlankWorkflow(profileId: string): AgentWorkflowDef {
  const now = Date.now();
  return {
    id: `wf-${profileId}-${now}`,
    name: "Default workflow",
    steps: [
      {
        id: `step-${now}-0`,
        type: "llm",
        label: "Understand & plan",
        instruction: "Understand the user request and plan the steps needed.",
        order: 0,
      },
    ],
    enabledToolIds: [...DEFAULT_ENABLED_TOOL_IDS],
    maxToolRounds: 10,
    updatedAt: now,
  };
}

export function createStep(type: AgentWorkflowStep["type"], order: number): AgentWorkflowStep {
  const id = `step-${Date.now()}-${order}`;
  const labels: Record<AgentWorkflowStep["type"], string> = {
    llm: "Reason / respond",
    web_search: "Web search",
    file_search: "File search",
    code_interpreter: "Code interpreter",
    image_generation: "Image generation",
    connector: "Connector (e.g. Shopify)",
  };
  return { id, type, label: labels[type], order };
}
